import { isOneToOneChat } from "@/firebase/utils";
import { ChatTypes } from "@/store/chats/types";

export const getChatTypeFromId = (chatId: string): ChatTypes => {
  if (isOneToOneChat(chatId)) return ChatTypes.ONE_TO_ONE_CHAT;
  return ChatTypes.GROUP_CHAT;
};
